export const uploadImage = async (file, isUrl = false) => {
  try {
    let formData = new FormData();
    
    if (isUrl) {
      // Per gli URL, usiamo il parametro 'file' con l'URL completo
      formData.append('file', file);
      formData.append('upload_preset', process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET);
      // Aggiungiamo il parametro per indicare che è un URL remoto
      formData.append('fetch_format', 'auto');
    } else {
      // Per i file locali, manteniamo il comportamento esistente
    formData.append('file', file);
    formData.append('upload_preset', process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET);
    }

    const response = await fetch(
      `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUDINARY_CLOUD_NAME}/image/upload`,
      {
        method: 'POST',
        body: formData,
      }
    );

    const data = await response.json();
    
    if (data.error) {
      throw new Error(data.error.message || 'Errore nel caricamento dell\'immagine');
    }

    return {
      url: data.secure_url,
      publicId: data.public_id
    };
  } catch (error) {
    console.error('Errore nel caricamento dell\'immagine:', error);
    throw error;
  }
};

export const deleteImage = async (publicId) => {
  try {
    const timestamp = Math.floor(Date.now() / 1000);
    const signature = await generateSignature(publicId, timestamp);

    const response = await fetch(
      `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUDINARY_CLOUD_NAME}/image/destroy`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          public_id: publicId,
          api_key: process.env.REACT_APP_CLOUDINARY_API_KEY,
          timestamp: timestamp,
          signature: signature
        })
      }
    );

    const data = await response.json();
    
    if (data.error) {
      throw new Error(data.error.message);
    }

    return data;
  } catch (error) {
    console.error('Errore durante l\'eliminazione da Cloudinary:', error);
    throw error;
  }
};

// Funzione per generare la firma per l'eliminazione delle immagini
const generateSignature = async (publicId, timestamp) => {
  const message = `public_id=${publicId}&timestamp=${timestamp}${process.env.REACT_APP_CLOUDINARY_API_SECRET}`;
  const encoder = new TextEncoder();
  const data = encoder.encode(message);
  const hashBuffer = await crypto.subtle.digest('SHA-1', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
  return hashHex;
}; 